import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const quickLinks = [
  { name: "Home", to: "/" },
  { name: "Shopping Guide", to: "/pandabuy-spreadsheet-guide" },
];

export default function Footer() {
  const half = Math.ceil(categories.length / 2);
  const leftCategories = categories.slice(0, half);
  const rightCategories = categories.slice(half);

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {/* Column 1: Brand + Quick Links */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  Pandabuy Sheet
                </a>
              </li>
            </ul>
          </div>

          {/* Column 2: Categories Part 1 */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-4">
              Categories
            </h4>
            <ul className="space-y-2.5">
              {leftCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Categories Part 2 */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-4">
              More Categories
            </h4>
            <ul className="space-y-2.5">
              {rightCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Brand Info */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-4">
              About
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              Your trusted pandabuy spreadsheet bridge. Compare products, track prices, and shop smarter across global platforms.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 hover:text-primary-500 text-foreground-500 transition-colors"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 hover:text-primary-500 text-foreground-500 transition-colors"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a
                href="https://tiktok.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 hover:text-primary-500 text-foreground-500 transition-colors"
                aria-label="TikTok"
              >
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-baseline gap-3">
            <span className="text-lg font-bold tracking-tight text-foreground-900">
              PandaBuy<span className="text-primary-500">.</span>Yachts
            </span>
            <span className="text-xs text-foreground-500">Smart Shopping</span>
          </div>
          <p className="text-xs text-foreground-500">
            &copy; 2026 PandaBuy Yachts. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}